import { render, staticRenderFns } from "./dialogHint.vue?vue&type=template&id=6e4bef37&scoped=true"
import script from "./dialogHint.vue?vue&type=script&lang=js"
export * from "./dialogHint.vue?vue&type=script&lang=js"
import style0 from "./dialogHint.vue?vue&type=style&index=0&id=6e4bef37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4bef37",
  null
  
)

export default component.exports